import { useState, useEffect } from "react";
import { Box, Typography, Grid, Paper, Button, useTheme } from "@mui/material";

import axios from "axios";

const Pitch = () => {
  const theme = useTheme();
  const [pitches, setPitches] = useState([]);

  useEffect(() => {
    getPitches();
  }, []);

  const getPitches = async () => {
    const result = await axios.get(
      `${process.env.REACT_APP_TNFT_SERVER}/pitches?eventId=695ee6a0f645fb6c59f0c6e7`,
    );
    if (result.status === 200 && result?.data?.success) {
      setPitches(result?.data?.pitches);
    }
  };

  return (
    <Box
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Grid container spacing={4} sx={{ maxWidth: 900, px: { xs: 2, sm: 2 } }}>
        <Grid
          item
          xs={12}
          style={{ display: "flex", justifyContent: "center" }}
        >
          <img
            src={"https://d1unewf2oslns8.cloudfront.net/main-squeeze-logo.png"}
            height="150px"
            alt="findyourmainsqueeze"
          />
        </Grid>
        <Grid item xs={12}>
          <Typography variant="h3" align="center">
            Pick Your Pitch
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="body1" align="center">
            Someone catch your eye on stage?
          </Typography>
          <Typography variant="body1" align="center">
            Find them on the list and shoot your shot!
          </Typography>
        </Grid>
        {pitches.map((p) => {
          return (
            <Grid item xs={12} key={p?._id || p?.order}>
              <Paper
                elevation={3}
                sx={{
                  borderRadius: "20px",
                  padding: "28px 36px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  backgroundColor: "#efefef",
                }}
              >
                <Typography variant="h6" sx={{ fontWeight: 500 }}>
                  {p?.name}
                </Typography>

                <Button
                  variant="contained"
                  onClick={() => {
                    if (p?.url) {
                      window.open(p.url, "_blank", "noopener,noreferrer");
                    }
                  }}
                  sx={{
                    backgroundColor: theme.palette.primary.dark,
                    borderRadius: "999px",
                    padding: "14px 48px",
                    fontWeight: 600,
                    letterSpacing: "0.5px",
                    "&:hover": {
                      backgroundColor: "#111",
                    },
                  }}
                >
                  PICK ME!
                </Button>
              </Paper>
            </Grid>
          );
        })}
        <Grid item xs={12} style={{ width: '100%', display: 'flex', justifyContent: 'center', marginBottom: 100 }}>
          <img
            src={"https://d1unewf2oslns8.cloudfront.net/natalies-xoxo.png"}
            alt="natalies-xoxo"
            style={{ maxWidth: '70%', height: 'auto', objectFit: 'contain' }}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default Pitch;
